import React from 'react';
export var ConfluenceSearchInitialStateSVG = function ConfluenceSearchInitialStateSVG() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "188",
    height: "112",
    viewBox: "0 0 188 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "25.5",
    y: "1",
    width: "127",
    height: "97",
    rx: "4",
    fill: "white",
    stroke: "#B7BDC8",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "24.5",
    y1: "10",
    x2: "152.5",
    y2: "10",
    stroke: "#B7BDC8",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "24.5",
    y1: "32",
    x2: "152.5",
    y2: "32",
    stroke: "#B7BDC8",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "24.5",
    y1: "54",
    x2: "152.5",
    y2: "54",
    stroke: "#B7BDC8",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "32",
    y: "18",
    width: "114",
    height: "5",
    rx: "2.5",
    fill: "#C1C7D0",
    fillOpacity: "0.4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "32",
    y: "41",
    width: "114",
    height: "5",
    rx: "2.5",
    fill: "#C1C7D0",
    fillOpacity: "0.4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "32",
    y: "84",
    width: "114",
    height: "5",
    rx: "2.5",
    fill: "#C1C7D0",
    fillOpacity: "0.4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "32",
    y: "62",
    width: "114",
    height: "5",
    rx: "2.5",
    fill: "#C1C7D0",
    fillOpacity: "0.4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "24.5",
    y1: "76",
    x2: "152.5",
    y2: "76",
    stroke: "#B7BDC8",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_10772)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "72",
    height: "72",
    transform: "translate(100.5 40)",
    fill: "white",
    fillOpacity: "0.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.011 90.5858L142.602 87.2253L147.304 82.5063L150.713 85.8668C151.581 86.7186 152.678 87.3021 153.872 87.5471C155.063 87.8204 156.155 88.4139 157.03 89.2631L170.885 102.884C171.892 103.878 172.464 105.228 172.478 106.641C172.491 108.053 171.944 109.414 170.957 110.427C169.953 111.425 168.595 111.989 167.177 111.995C165.759 112.002 164.396 111.451 163.383 110.463L149.529 96.842C148.659 95.9778 148.049 94.8879 147.77 93.696C147.512 92.5065 146.899 91.4224 146.011 90.5858Z",
    fill: "#CFD4DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.011 90.5858L144.971 89.549C144.659 89.243 144.412 88.8785 144.243 88.4765C144.074 88.0745 143.987 87.6431 143.987 87.2074C143.987 86.7717 144.074 86.3403 144.243 85.9383C144.412 85.5363 144.659 85.1718 144.971 84.8658C145.275 84.5532 145.64 84.3041 146.042 84.1329C146.444 83.9617 146.877 83.8718 147.314 83.8685C147.751 83.8652 148.185 83.9485 148.59 84.1135C148.995 84.2786 149.363 84.5222 149.672 84.8301L150.713 85.8668C151.581 86.7186 152.678 87.3021 153.872 87.547C155.063 87.8204 156.155 88.4139 157.03 89.263L170.885 102.884C171.892 103.878 172.464 105.228 172.478 106.641C172.491 108.053 171.944 109.414 170.957 110.427C169.953 111.425 168.595 111.989 167.177 111.995C165.759 112.002 164.396 111.451 163.383 110.463L149.529 96.842C148.659 95.9778 148.049 94.8879 147.77 93.696C147.512 92.5065 146.899 91.4224 146.011 90.5858Z",
    fill: "#8270DB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: "0.2",
    d: "M147.734 93.5887C147.458 92.4449 146.861 91.4032 146.011 90.5858L144.971 89.549C144.659 89.243 144.412 88.8785 144.243 88.4765C144.074 88.0745 143.987 87.6431 143.987 87.2074C143.987 86.7717 144.074 86.3403 144.243 85.9383C144.412 85.5363 144.659 85.1718 144.971 84.8658C145.275 84.5532 145.64 84.3041 146.042 84.1329C146.444 83.9617 146.877 83.8718 147.314 83.8685C147.752 83.8652 148.185 83.9485 148.59 84.1135C148.995 84.2786 149.363 84.5222 149.672 84.8301L150.713 85.8668C151.539 86.6914 152.586 87.2622 153.728 87.5113C152.888 88.6723 151.964 89.7714 150.965 90.8003C149.956 91.8048 148.876 92.7366 147.734 93.5887Z",
    fill: "#403294"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.313 67.599C156.268 62.1046 154.591 56.7464 151.493 52.2003C148.395 47.6542 144.014 44.124 138.904 42.0551C133.794 39.9861 128.182 39.4712 122.778 40.5752C117.374 41.6792 112.42 44.3527 108.54 48.2583C105.959 50.8491 103.919 53.924 102.539 57.3052C101.159 60.6864 100.466 64.3067 100.5 67.9565C100.515 71.6054 101.255 75.2154 102.678 78.5778C104.101 81.9403 106.179 84.9888 108.791 87.5473C112.721 91.4036 117.71 94.0141 123.128 95.0494C128.545 96.0846 134.15 95.4982 139.234 93.3642C144.317 91.2302 148.652 87.6442 151.692 83.0587C154.732 78.4732 156.339 73.0937 156.313 67.599Z",
    fill: "#66A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.678 51.6186C110.935 54.7774 108.407 59.1306 107.525 63.9371C106.643 68.7435 107.46 73.706 109.838 77.9797C112.216 82.2534 116.008 85.574 120.567 87.3761C125.127 89.1783 130.173 89.3507 134.846 87.8638C139.519 86.377 143.53 83.3229 146.197 79.2215C148.863 75.1202 150.02 70.2251 149.47 65.3697C148.92 60.5144 146.698 55.9989 143.181 52.5921C139.665 49.1853 135.071 47.0979 130.183 46.6851C127.4 46.4461 124.596 46.7591 121.935 47.6059C119.273 48.4527 116.807 49.8165 114.678 51.6186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_10772"
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: "107",
    y: "46",
    width: "43",
    height: "43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.66 51.7782C110.928 54.9501 108.416 59.3122 107.55 64.1217C106.684 68.9312 107.519 73.8908 109.912 78.1561C112.305 82.4214 116.109 85.7287 120.675 87.5149C125.241 89.3011 130.287 89.4558 134.955 87.9526C139.623 86.4494 143.623 83.3813 146.275 79.2706C148.927 75.1599 150.067 70.2608 149.5 65.4074C148.933 60.554 146.695 56.0463 143.166 52.6519C139.638 49.2574 135.037 47.1861 130.148 46.7904C127.363 46.5612 124.561 46.884 121.902 47.7401C119.244 48.5962 116.782 49.9687 114.66 51.7782Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_10772)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "-9.11658",
    y: "60.6511",
    width: "152.638",
    height: "10.2857",
    rx: "5.14286",
    transform: "rotate(-0.200699 -9.11658 60.6511)",
    fill: "#C1C7D0",
    fillOpacity: "0.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3882 50.885L151.465 50.594",
    stroke: "#B7BDC8",
    strokeWidth: "4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "68.4865",
    y1: "78.9508",
    x2: "151.563",
    y2: "78.6598",
    stroke: "#B7BDC8",
    strokeWidth: "4"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_10772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "72",
    height: "72",
    fill: "white",
    transform: "translate(100.5 40)"
  }))));
};